import { Action } from '@ngrx/store';
import { SitesView } from '../../../_generated';
export enum SitesAction {
  Load = '[Sites] Load',
  Get = '[Sites] Get',
  Reset = '[Sites] Reset',
  UpdateParameterStatus = '[Sites] Update Parameter Entry Cycle Status',
}

export class Load implements Action {
  readonly type = SitesAction.Load;
}

export class Get implements Action {
  readonly type = SitesAction.Get;

  constructor(public payload: SitesView[]) {}
}

export class Reset implements Action {
  readonly type = SitesAction.Reset;
}

export class UpdateParameterStatus implements Action {
  readonly type = SitesAction.UpdateParameterStatus;

  constructor(
    public payload: {
      siteId: number;
      shopId: number;
      toolId: number;
      emissionPointId: number;
      parameterId: number;
      status: any;
    },
  ) {}
}

export type SitesActionType = Load | Get | Reset | UpdateParameterStatus;
